import { render, staticRenderFns } from "./aliyunCaptcha.vue?vue&type=template&id=80cd11b4&"
import script from "./aliyunCaptcha.vue?vue&type=script&lang=js&"
export * from "./aliyunCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./aliyunCaptcha.vue?vue&type=style&index=0&id=80cd11b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports